import { createFileRoute } from '@tanstack/react-router';

import { NotificationsTab } from '@/components/settings/notifications/notifications-tab';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute(
  '/_authenticated/agency/settings/notifications',
)({
  loader: () => loadNamespaces('settings'),
  staticData: {
    title: 'route.settings_notifications.title',
  },
  component: NotificationsTab,
});
